<script setup lang="ts">
import PdfDisplay from '@/components/onOffBoarding/PdfDisplay.vue'
import SvgSpinnersPulseRings3 from '~icons/svg-spinners/pulse-rings-3'

defineProps<{
  isOpening: boolean
  linkUrl: string
  title: string
  openingLabel: string
}>()
</script>

<template>
  <div class="relative h-[90vh] w-[80vw] md:h-[800px] md:w-[60vw] xl:h-[900px] xl:w-[800px]" data-cy="signature-document-frame">
    <div
      v-if="isOpening"
      class="absolute inset-0 z-10 flex flex-col items-center justify-center rounded-lg bg-base/80 backdrop-blur-xs"
    >
      <SvgSpinnersPulseRings3 class="mb-4 text-5xl text-primary-500" />
      <span class="text-sm font-medium text-color-base">{{ openingLabel }}</span>
    </div>
    <iframe
      v-else-if="linkUrl && !linkUrl.startsWith('data:')"
      :src="linkUrl"
      :title="title"
      referrerpolicy="strict-origin-when-cross-origin"
      class="h-full w-full rounded-lg border border-base shadow-xs"
    />
    <PdfDisplay
      v-else-if="linkUrl"
      :file-path="linkUrl"
      class="h-full w-full overflow-hidden rounded-lg border border-base shadow-xs"
    />
  </div>
</template>
